<template>
    <div class="nav-item-m" align="center" :class="{ active: isActive }" @click="navigatorItemClick()">
      {{item.text}}
    </div>
</template>

<script>
import 'vue-awesome/icons/area-chart';
import 'vue-awesome/icons/plus-circle';
import 'vue-awesome/icons/file-text-o';
import 'vue-awesome/icons/calendar-check-o';
import 'vue-awesome/icons/inbox';
import 'vue-awesome/icons/eye';
import 'vue-awesome/icons/archive';
import Icon from 'vue-awesome/components/Icon';

import {mapGetters, mapActions} from 'vuex';
export default {
  name: 'navigatorItem',
  components: {
    Icon
  },
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      isActive: false
    }
  },
  computed: {
    number () {
      return this.showRelatedEvents ? this.item.count : this.countEventByStatus(this.item.eventStatus);
    },
    ...mapGetters({
      countEventByStatus: 'GETTERS_COUNT_EVENT_BY_STATUS',
      showRelatedEvents: 'GETTERS_SHOW_RELATED_EVENT'
    })
  },
  methods: {
    ...mapActions({
      setListEventStatus: 'ACTION_SET_LIST_EVENT_STATUS'
    })
  }
};
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';
.active {
  color: @black !important;
  background: @white;
}

.nav-item-m {
  font-size: 13px;
  line-height: 12px;
  text-align: center;
  position: relative;
  padding-top: 15px;
  .nav-icon {
    font-family: FontAwesome, sans-serif;
    font-size: 14px;
    line-height: 14px;
    // float: left;
    height: 14px;
    width: 14px;
    position: absolute;
    margin: 0px;
  }
  .nav-text {
    text-align: left;
    // margin-left: 25px;
    height: 24px;
    line-height: 15px;
    margin-left: 20px;
    font-family: @font-family-main;
    font-size: 14px;
    .company-name{
      margin: 0 0 0 33px;
    }
  }
  .nav-number {
    height: 38px;
    width: 42px;
    font-size: 36px;
    line-height: 49px;
    position: absolute;
    bottom: 14px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
  }
  .nav-underline {
    height: 5px;
    width: 76px;
    bottom: 0;
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }
  .line-white {
    background-color: @grey-4;
  }
  .line-blue {
    background-color: @light-blue;
  }
  .line-red {
    background-color: @red;
  }
  .line-green {
    background-color: @green;
  }
  .line-brown {
    background-color: @brown;
  }
}
</style>



// WEBPACK FOOTER //
// NavigatorItem.vue?2d92d540